module.exports = __webpack_public_path__ + "img/twotter.91a283bb.png";